
export const COMPONENT_NAME_MAP = 'MapViewer';
export const COMPONENT_NAME_MAPBASIC = 'MapBasicViewer';
export const COMPONENT_NAME_MULTISCENE = 'MultiSceneViewer';
export const COMPONENT_NAME_MULTISCENEBASIC = 'MultiSceneBasicViewer';
export const COMPONENT_NAME_MAPMULTISCENE = 'MapMultiSceneViewer';
export const COMPONENT_NAME_MAPMULTISCENEBASIC = 'MapMultiSceneBasicViewer';
export const COMPONENT_NAME_SPHEREPHOTO = 'SpherePhotoViewer';
export const COMPONENT_NAME_SPHEREPHOTOBASIC = 'SpherePhotoBasicViewer';

function existsMultiSceneProjectUrl(projectDefinition) {
    return (
        projectDefinition &&
        projectDefinition.multiSceneProject &&
        projectDefinition.multiSceneProject.url
    );
}

function checkProjectForLayoutMultiScene(projectDefinition) {
    return existsMultiSceneProjectUrl(projectDefinition);
}

function checkProjectForLayoutMultiSceneBasic(projectDefinition) {
    return existsMultiSceneProjectUrl(projectDefinition);
}

function checkProjectForLayoutMapMultiScene(projectDefinition) {
    return existsMultiSceneProjectUrl(projectDefinition);
}

function checkProjectForLayoutMapMultiSceneBasic(projectDefinition) {
    return existsMultiSceneProjectUrl(projectDefinition);
}

function checkProjectForLayoutSpherePhoto(projectDefinition) {
    return existsMultiSceneProjectUrl(projectDefinition);
}

export function checkProjectForLayout(componentName, projectDefinition) {
    switch (componentName) {
        case COMPONENT_NAME_MAP:
            return true;
        case COMPONENT_NAME_MAPBASIC:
            return true;
        case COMPONENT_NAME_MULTISCENE:
            return checkProjectForLayoutMultiScene(projectDefinition);
        case COMPONENT_NAME_MULTISCENEBASIC:
            return checkProjectForLayoutMultiSceneBasic(projectDefinition);
        case COMPONENT_NAME_MAPMULTISCENE:
            return checkProjectForLayoutMapMultiScene(projectDefinition);
        case COMPONENT_NAME_MAPMULTISCENEBASIC:
            return checkProjectForLayoutMapMultiSceneBasic(projectDefinition);
        case COMPONENT_NAME_SPHEREPHOTO:
            return checkProjectForLayoutSpherePhoto(projectDefinition);
        case COMPONENT_NAME_SPHEREPHOTOBASIC:
            return checkProjectForLayoutSpherePhoto(projectDefinition);
        default:
            return false;
    }
}
